import { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

const AuthContext = createContext({});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [profil, setProfil] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
      if (session?.user) fetchProfil(session.user.id);
      else setLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
      if (session?.user) fetchProfil(session.user.id);
      else { setProfil(null); setLoading(false); }
    });

    return () => subscription.unsubscribe();
  }, []);

  async function fetchProfil(userId) {
    const { data } = await supabase.from('kullanicilar').select('*').eq('id', userId).single();
    setProfil(data);
    setLoading(false);
  }

  async function girisYap(email, sifre) {
    const { error } = await supabase.auth.signInWithPassword({ email, password: sifre });
    return { error };
  }

  async function cikisYap() {
    await supabase.auth.signOut();
  }

  return (
    <AuthContext.Provider value={{ user, profil, loading, girisYap, cikisYap }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
